//admin utility
import { HttpClient, HttpParams } from '@angular/common/http';
declare var $;
import { AfterViewInit, Component, OnInit, ViewChild ,ElementRef} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { ResidentialService } from 'src/app/questionarie-signup/questionnaire-residential/residential.service';
import { MatTable } from '@angular/material/table';
import { _ } from 'underscore';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { EnergyProvidersModalComponent } from '../../admin-utility/energy-providers-modal/energy-providers-modal.component';
import { SnackbarComponent } from '../../snackbar/snackbar.component';
import {
  
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';

// import { AdminUtilityReportComponent } from '../admin-utility/admin-utility-report/admin-utility-report.component'
import { ItemsList } from '@ng-select/ng-select/ng-select/items-list';
import { environment } from '../../../environments/environment';
import * as moment from 'moment-timezone';
import { DatePipe } from '@angular/common';
import { Block } from '../../shared/models/block';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators, FormControlName, AbstractControl
} from '@angular/forms';
import { Observable, fromEvent, merge } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import {NgbModal, NgbActiveModal, NgbModule, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import { Clipboard } from '@angular/cdk/clipboard';
/**
 * @title Table with pagination
 */
@Component({
  selector: 'app-admin-affiliation',
  templateUrl: './admin-affiliation.component.html',
  styleUrls: ['./admin-affiliation.component.css'],
  providers: [DatePipe],

  entryComponents: [SnackbarComponent],
})

export class AdminAffiliationComponent implements OnInit {


  Status;
  copyText() {
    this.clipboard.copy(this.managerMaintenanceForm.get('AffiliateLink').value);

    setTimeout(function(){
      $('[data-toggle="tooltip"], .tooltip').tooltip("hide");
    },1000)
  }
  ngbModalOptions: NgbModalOptions = {
    backdrop : 'static',
    keyboard : false
  };
  modalRef: BsModalRef;
  msg;
  title;
  @ViewChild('SuccessModel', { static: true }) SuccessModel: ElementRef;
  // Use with the generic validation message class
  AffilateId;
  pageheadername;

  managerMaintenanceForm = this.fb.group({
    AffiliateName: [, Validators.required],
    ContactPerson: [, Validators.required],
    Address: [, Validators.required],
    Email: new FormControl('', Validators.compose([
      Validators.required,
      Validators.pattern('^([a-zA-Z0-9_.+-])+\\@(([a-zA-Z0-9-])+\\.)+([a-zA-Z0-9]{2,4})+$')
    ])),
    Phone: new FormControl('', Validators.compose([
      Validators.required,
      Validators.pattern('^\\(?([0-9]{3})\\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$')
    ])),
    AffiliateLink: [, Validators.required]
    
  });

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private router: Router,
    private residentialService: ResidentialService,
    public dialog: MatDialog,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private modalService: BsModalService,
    private clipboard: Clipboard
  ) {

    

  }

  account_validation_messages = {
   
    'Email': [
      { type: 'required', message: 'The email field is required' },
      { type: 'pattern', message: 'Please enter a valid email address.' }
    ],
    'AffiliateName': [
      { type: 'required', message: 'The affiliate name field is required' },
    ],
    'ContactPerson':[
      { type: 'required', message: 'The contact person field is required' },
    ],
    'Address':[
      { type: 'required', message: 'The address field is required' },
    ],
    'Phone':[
      { type: 'required', message: 'The phone field is required' },
      { type: 'pattern', message: 'Please enter a valid phone number.' }
    ],
    'AffiliateLink': [
      { type: 'required', message: 'The affiliate link field is required' },
    ],
    }
    openModal(template: ElementRef<any>) {
      this.modalRef = this.modalService.show(
        template,
        Object.assign({}, { class: 'gray modal-small' },this.ngbModalOptions)
      );
    }

  ngOnInit() {

    
    $('[data-toggle="tooltip"]').tooltip({
      animated: 'fade',
      placement: 'bottom',
      trigger: 'click'
  });



    $('#AffiliateName').keypress(function( e ) {
      if( e.which === 32 || e.which == 47 || e.which == 92) 
          return false;
    });
    this.pageheadername = "Create Affiliate";
    this.route.params.subscribe(params => {
    
      this.AffilateId = params['id']

    });
   if(this.AffilateId != undefined && this.AffilateId != "")
   {
    this.pageheadername = "Edit Affiliate";
    this.getAffilationsInfobyId();
   }
    
    $("#Phone").mask("(000) 000-0000")
    
  }

  getAffilationsInfobyId() {
    this.residentialService
      .GetAffilationById(this.AffilateId)
      .subscribe((response: any) => {
        // console.log(response);
        if(response.length != 0)
        {
          this.managerMaintenanceForm.setValue({
            AffiliateName: response[0].AffiliateName,
            ContactPerson: response[0].ContactPerson,
            Email: response[0].Email,
            Phone: response[0].Phone,
            Address: response[0].Address,
            AffiliateLink: response[0].AffiliateLink ? response[0].AffiliateLink : ''
          });
          this.Status = response[0].Status
        }




      });
  }

  valueChanged(event) {
    if (event) {
     
    }
  }
  dateObjectCstFormatted() {
    // return moment(new Date(this.model))
    //   .format('YYYY-MM-DD HH:mm:ss')
    //   .toString();
  }

  AddEditAffilations(form){
    var UserID;
    if (!_.isEmpty(sessionStorage.getItem('userObj'))) {
      let result = JSON.parse(sessionStorage.getItem('userObj'));
      if (result.userObj._id) {
        UserID = result.userObj._id;
      } 
    }

    if (this.managerMaintenanceForm.valid) {
     

      var link =   this.Generatelink();
      var AffilationModel = {
        _id: this.AffilateId,
        AffiliateName: form.AffiliateName,
        ContactPerson: form.ContactPerson,
        Email: form.Email,
        Phone: form.Phone,
        Address: form.Address,
        Status: this.Status == '' || this.Status == undefined || this.Status == null ? 'Active' : this.Status,
        CreatedBy: UserID,
        AffiliateLink : link,
        SuspendedDate : ''


      };

      this.residentialService
      .SaveAffilationForm(AffilationModel)
      .subscribe((response: any) => {
        this.msg ="Affiliate has been created successfully";
        if(this.pageheadername.indexOf('Edit') > -1 )
        {
          this.msg ="Affiliate has been updated successfully";
        }
        this.title = this.pageheadername;
        
        this.router.navigate([
          'hg-admin-affiliate-addedit',
          response,
        ]);

        this.openModal(this.SuccessModel);

      });


    }else
    {
      this.managerMaintenanceForm.markAllAsTouched();
    }

  }

  Generatelink()
  {
    
    var a = this.managerMaintenanceForm.get('AffiliateName').value;
   
    var AffiliateLink_ = this.residentialService.GenerateLink(a, '');
     this.managerMaintenanceForm.get('AffiliateLink').setValue(AffiliateLink_);
     return AffiliateLink_;
    //this.managerMaintenanceForm.setValue({AffiliateLink:AffiliateLink_});
  }

}
